import React from 'react';
import socket from '../socket';

const ShowRoundResults = ({ player, gameSyncData, gameHistory, role, gameStarted }) => {
  const totalTeams = Object.keys(gameSyncData.teams || {}).length;
  const isLastTeam = gameSyncData.currentTeamIndex + 1 === totalTeams;
  const latestRoundResults = gameHistory[gameHistory.length - 1];
  const isTeamMode = latestRoundResults.teamScores && Object.keys(latestRoundResults.teamScores).length > 0;
  const playerId = player.id;

  const Tooltip = ({ children, text }) => (
  <div className="relative group inline-block">
    {children}
    <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity z-20">
      {text}
    </div>
  </div>
);

  const handleProceedNext = () => {
    if (role === 'host' && gameStarted) {
      socket.emit('host-proceed-next', gameSyncData.roomId);
    }
  };

  return (
    <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
      <div className="bg-white relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-2xl min-h-[60vh] max-h-[70vh] overflow-y-auto p-4 sm:p-6 shadow-xl transition-all duration-300 animate-fade-in text-black">
        <h2 className="text-xl sm:text-3xl font-bold text-center mb-2" style={{ color: '#282828' }}>
          🏆 Round {latestRoundResults.round} Results
        </h2>
        <hr className="border-t-2 border-gray-300 mb-4" />

        {isTeamMode ? (
          <div className="space-y-6 pr-1 max-h-[50vh] overflow-y-auto">
            {Object.entries(latestRoundResults.teamScores).map(([teamName, score], index) => (
              <div key={index} className="mb-6">
                <h3 className="font-semibold text-md sm:text-lg mb-2" style={{ color: '#282828' }}>
                  🚩 {teamName}{' '}
                  <span className="text-sm font-normal text-gray-500 notranslate" translate="no">
                    ({score} pts)
                  </span>
                </h3>
                <ul className="ml-2 space-y-2">
                  {(latestRoundResults.playerScores?.[teamName] || []).length > 0 ? (
                    latestRoundResults.playerScores[teamName]
                      .sort((a, b) => b.score - a.score)
                      .map((player, i) => {
                        const isPlayerHost = player.id === gameSyncData.hostId;
                        const isCurrentUser = player.id === playerId;
                        const rowBgColor = isCurrentUser
                          ? '#2A71F5'
                          : i % 2 === 0
                          ? '#F6EFEF'
                          : '#DBDBDB';

                        return (
                          <li
                            key={player.id}
                            className="text-sm sm:text-base px-4 py-2 rounded-full flex justify-between items-center"
                            style={{
                              backgroundColor: rowBgColor,
                              color: isCurrentUser ? '#FFFFFF' : '#282828',
                            }}
                          >
                            <span className="notranslate truncate flex-1" translate="no">
                              🎮 {player.name}
                            </span>

                            <div className="flex items-center gap-2 text-sm">
                              <span className="flex items-center cursor-default">{isPlayerHost ? <Tooltip text="Host">⭐</Tooltip> : null}</span>
                              <span className="notranslate font-semibold text-nowrap ml-2" translate="no">
                                {player.score} pts
                              </span>
                            </div>

                          </li>
                        );
                      })
                  ) : (
                    <li className="text-gray-500 italic text-sm">No players in this team</li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <div className="space-y-2 pr-1 max-h-[50vh] overflow-y-auto">
            {latestRoundResults.playerScores && latestRoundResults.playerScores.length > 0 ? (
              latestRoundResults.playerScores
                .sort((a, b) => b.score - a.score)
                .map((player, i) => {
                  const isPlayerHost = player.id === gameSyncData.hostId;
                  const isCurrentUser = player.id === playerId;
                  const rowBgColor = isCurrentUser
                    ? '#2A71F5'
                    : i % 2 === 0
                    ? '#F6EFEF'
                    : '#DBDBDB';

                  return (
                    <div
                      key={player.id}
                      className="flex justify-between items-center px-4 py-2 rounded-full text-sm sm:text-base"
                      style={{
                        backgroundColor: rowBgColor,
                        color: isCurrentUser ? '#FFFFFF' : '#282828',
                      }}
                    >
                      <span className="notranslate font-semibold truncate flex-1" translate="no">
                        🎮 {player.name}
                      </span>
                            <div className="flex items-center gap-2 text-sm">
                              <span className="flex items-center cursor-default">{isPlayerHost ? <Tooltip text="Host">⭐</Tooltip> : null}</span>
                              <span className="notranslate font-semibold text-nowrap ml-2" translate="no">
                                {player.score} pts
                              </span>
                            </div>
                    </div>
                  );
                })
            ) : (
              <p className="text-gray-500 text-center text-sm">No player scores available.</p>
            )}
          </div>
        )}

        {role === 'host' && gameStarted && (
          <button
            onClick={handleProceedNext}
            className="mt-4 w-full py-2 rounded-xl bg-indigo-600 text-white font-bold hover:bg-indigo-700 transition-all"
          >
            {gameSyncData?.gameMode === 'single'
              ? 'Next Round ➡️'
              : isLastTeam
              ? 'Next Round ➡️'
              : 'Next Team 🔁'}
          </button>
        )}
      </div>
    </div>
  );

};

export default ShowRoundResults;
